import { Type } from '@sinclair/typebox';

const previewResponseSchema = Type.Object({
    assets: Type.Object({
        total: Type.Number(),
        alreadyEmbedded: Type.Number(),
        toProcess: Type.Number(),
    }),
    surveys: Type.Object({
        total: Type.Number(),
        alreadyEmbedded: Type.Number(),
        toProcess: Type.Number(),
    }),
});

const startRequestSchema = Type.Object({
    clientCompanyId: Type.String({ format: 'uuid' }),
    startDate: Type.String(),
    endDate: Type.String(),
    includeAssets: Type.Optional(Type.Boolean()),
    includeSurveys: Type.Optional(Type.Boolean()),
});

const startResponseSchema = Type.Object({
    assetsQueued: Type.Number(),
    surveysQueued: Type.Number(),
    assetsSkipped: Type.Number(),
    surveysSkipped: Type.Number(),
});

const cancelPendingRequestSchema = Type.Object({
    clientCompanyId: Type.String({ format: 'uuid' }),
});

const cancelPendingResponseSchema = Type.Object({
    cancelled: Type.Number(),
});

const pendingStatsResponseSchema = Type.Object({
    pending: Type.Number(),
    active: Type.Number(),
    retry: Type.Number(),
});

const queryParameters = [
    {
        name: 'clientCompanyId',
        in: 'query' as const,
        schema: Type.String({ format: 'uuid' }),
    },
    {
        name: 'startDate',
        in: 'query' as const,
        schema: Type.String(),
    },
    {
        name: 'endDate',
        in: 'query' as const,
        schema: Type.String(),
    },
];

export const aiBackfillPaths = {
    '/api/ai/backfill/preview': {
        get: {
            operationId: 'aiBackfillControllers.preview',
            parameters: queryParameters,
            responses: {
                '200': {
                    description: 'Preview counts of documents and surveys eligible for backfill',
                    content: {
                        'application/json': {
                            schema: previewResponseSchema,
                        },
                    },
                },
            },
        },
    },
    '/api/ai/backfill/start': {
        post: {
            operationId: 'aiBackfillControllers.start',
            requestBody: {
                content: {
                    'application/json': {
                        schema: startRequestSchema,
                    },
                },
            },
            responses: {
                '200': {
                    description: 'Backfill jobs queued',
                    content: {
                        'application/json': {
                            schema: startResponseSchema,
                        },
                    },
                },
            },
        },
    },
    '/api/ai/backfill/pending': {
        get: {
            operationId: 'aiBackfillControllers.pending',
            parameters: [
                {
                    name: 'clientCompanyId',
                    in: 'query' as const,
                    schema: Type.String({ format: 'uuid' }),
                },
            ],
            responses: {
                '200': {
                    description: 'Counts of EmbedDocumentJob entries in the queue for this tenant',
                    content: {
                        'application/json': {
                            schema: pendingStatsResponseSchema,
                        },
                    },
                },
            },
        },
    },
    '/api/ai/backfill/cancel-pending': {
        post: {
            operationId: 'aiBackfillControllers.cancelPending',
            requestBody: {
                content: {
                    'application/json': {
                        schema: cancelPendingRequestSchema,
                    },
                },
            },
            responses: {
                '200': {
                    description: 'Number of pending/retry EmbedDocumentJob entries cancelled for this tenant',
                    content: {
                        'application/json': {
                            schema: cancelPendingResponseSchema,
                        },
                    },
                },
            },
        },
    },
} as const;
